import type { AdRuleType, AstDefineTagParams } from "@omni/ads";
import type { Ad } from "../../../../types/ads/adResource";
import type { PlaceholderConfigs } from "../../../../types/injectables";

import { getLayout, sizeToArray } from ".";

const isPlaceholderConfigType = (
  config: PlaceholderConfigs | Ad,
): config is PlaceholderConfigs => {
  return (
    typeof config === "object" &&
    config !== null &&
    ("mobile" in config || "desktop" in config)
  );
};

const createTag = (deviceSpecificConfig: AdRuleType): AstDefineTagParams => ({
  invCode: deviceSpecificConfig.appnexus_data!.inventory_code,
  sizes: deviceSpecificConfig.appnexus_data!.sizes.map(sizeToArray),
  targetId: deviceSpecificConfig.rules.position,
  enableSafeFrame: true,
  setSafeFrameConfig: {
    allowExpansionByPush: true,
    allowExpansionByOverlay: true,
  },
  allowedFormats: deviceSpecificConfig.appnexus_data?.allowed_formats,
  keywords: {
    "se-generic-adformat":
      deviceSpecificConfig.appnexus_data?.ad_formats &&
      deviceSpecificConfig.appnexus_data.ad_formats.length > 0
        ? deviceSpecificConfig.appnexus_data.ad_formats
        : [],
  },
});

const astTagCreator = (configs: (PlaceholderConfigs | Ad)[]) => {
  const deviceType = getLayout();
  const tags = configs.reduce<AstDefineTagParams[]>((configTags, config) => {
    if (isPlaceholderConfigType(config)) {
      const deviceSpecificConfig = config[deviceType];
      if (deviceSpecificConfig) {
        const tag = createTag(deviceSpecificConfig);
        return [...configTags, tag];
      }
      return configTags;
    } else {
      if (
        config.placementRules.length > 1 &&
        config.placeholderValues[deviceType]
      ) {
        const deviceSpecificConfig = config.placementRules.filter((rule) =>
          rule.rules.position.toLowerCase().includes(deviceType.toLowerCase()),
        );
        if (deviceSpecificConfig.length > 0) {
          const tag = createTag(deviceSpecificConfig[0]);
          return [...configTags, tag];
        }
      } else if (
        config.placementRules.length === 1 &&
        config.placeholderValues[deviceType]
      ) {
        const deviceSpecificConfig = config.placementRules[0];
        const tag = createTag(deviceSpecificConfig);
        return [...configTags, tag];
      }
      return configTags;
    }
  }, []);

  return tags;
};

export { astTagCreator };
